module.exports = __webpack_public_path__ + "static/people_img2-c13cf7c3c9a64fa3aef816e501bad114.png";